import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
var iconSizeMap = {
    lg: '40',
    md: '32',
    sm: '24',
    xs: '16',
};
var componentClass = 'btn--icon';
var IconButton = (function (_super) {
    __extends(IconButton, _super);
    function IconButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconButton.prototype.render = function () {
        var _a;
        var _b = this.props, _c = _b.type, type = _c === void 0 ? 'button' : _c, _d = _b.component, Component = _d === void 0 ? 'button' : _d, _e = _b.variant, variant = _e === void 0 ? 'primary' : _e, _f = _b.size, size = _f === void 0 ? 'md' : _f, _g = _b.disabled, disabled = _g === void 0 ? false : _g, icon = _b.icon, innerRef = _b.innerRef, className = _b.className, otherProps = __rest(_b, ["type", "component", "variant", "size", "disabled", "icon", "innerRef", "className"]);
        var classes = cx(bcx(componentClass, (_a = {},
            _a[variant] = variant,
            _a[size] = size,
            _a.disabled = disabled,
            _a)), className);
        var isButton = Component === 'button';
        var iconSize = iconSizeMap[size];
        var iconClone = React.cloneElement(icon, { size: iconSize });
        return (React.createElement(Component, __assign({ ref: innerRef, className: classes, disabled: disabled }, (isButton && {
            type: type,
        }), otherProps), iconClone));
    };
    return IconButton;
}(React.Component));
var IconButtonRef = React.forwardRef(function (props, ref) { return React.createElement(IconButton, __assign({}, props, { innerRef: ref })); });
IconButtonRef.displayName = 'Button';
export { IconButtonRef as IconButton };
//# sourceMappingURL=IconButton.js.map